import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const ProfitInformationPDF = () => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    return (
        <Panel title="Profit Information">
            <DataRow label="Vehicle" value={pdfData.vehicle_profit.toDollarFormat()} variant="muted"/>
            <DataRow label="Trade"   value={pdfData.trade_profit.toDollarFormat()}   variant="muted"/>
            <DataRow
                label="Total Profit"
                value={pdfData.total_profit.toDollarFormat()}
                isTotal
                variant="muted"
                isLast
            />
        </Panel>
    )
}
